import React from 'react'
import PropTypes from 'prop-types'
import FilterIcon from '../ui/Checkbox/FilterIcon'
import FabricSearch from './FabricSearch';
import CloseIcon from '../icons/CloseIcon';
import RitIconButton from '../RitIconButton';

const FabricHeader = ({
  onShowFilterClick,
  onSearch,
  filtersCount,
  isMobile,
  filterMenuOpened }) => {
  let icon = <FilterIcon />
  if (filterMenuOpened) {
    icon = <CloseIcon />
  }
  return (
    <div className='fabric-builder__header'>
      <div className='fabric-builder__title'>
        Ткани
      </div>
      <div className='fabric-builder__counter'
        onClick={isMobile ? onShowFilterClick : null}
      >  
        {filtersCount > 0 && `ФИЛЬТРЫ (${filtersCount})`}
      </div>

      <RitIconButton
        labelClass='fabric-builder__filter-button'
        onClick={onShowFilterClick}
      >
        {icon}
      </RitIconButton>

      <div className='fabric-builder__fiter-search'>
        <div className='fabric-builder__search-bar'>
          <FabricSearch onSearch={onSearch} isMobile={isMobile}/>
        </div>
      </div>
    </div>
  )

}
FabricHeader.propTypes = {
  onShowFilterClick: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  filtersCount: PropTypes.number.isRequired,
  isMobile: PropTypes.bool,
  filterMenuOpened: PropTypes.bool.isRequired,
}

export default FabricHeader;
